import { keyify } from './index';

/**
 * Returns the given lock by it's key.
 * 
 * @param {string|int|array} key
 * @returns {Object}
 */
export const getLock = (state) => (key) => {
  key = keyify(key);
  const item = state.locks.find(l => l.key === key);
  if (!item) {
    return null;
  }
  
  return item;
};
